import ProjectsRepo from "../../repositories/projects";
import ArticlesRepository from "../../repositories/articlesRepo";
import { productsObject } from "../../utils/products";

export default {
  namespaced: true,
  state: {
    items: [],
    totalItems: 0,
    pagination: {
      page: 1,
      itemsPerPage: 10
    },

    filter: {
      date_type: "created_at",
      date_from: null,
      date_to: null,
      applicator: null,
      unprocessed: null,
      search: null
    },

    project: null,

    planning_projects: [],

    list_datatable_parameters: {},

    // Search info on list
    list_search: {
      date_type: "CREATE",

      date_from: "2019-11-01",
      date_to: "2020-11-01", // TODO: now + 1y

      applicator: undefined,
      dialog_date_from: false,
      dialog_date_to: false
    }
  },
  mutations: {
    SET_PAGINATION(state, payload) {
      state.pagination = payload;
    },

    SET_DATE_TYPE_FILTER(state, payload) {
      state.filter.date_type = payload;
    },

    SET_DATE_FROM_FILTER(state, payload) {
      state.filter.date_from = payload;
    },

    SET_DATE_TO_FILTER(state, payload) {
      state.filter.date_to = payload;
    },

    SET_APPLICATOR_FILTER(state, payload) {
      state.filter.applicator = payload;
    },

    SET_UNPROCESSED_FILTER(state, payload) {
      state.filter.unprocessed = payload;
    },

    SET_SEARCH_FILTER(state, payload) {
      state.filter.search = payload;
    },

    SET_ITEMS(state, { items, totalItems }) {
      state.items = items;
      state.totalItems = totalItems;
    },

    SET_PROJECT(state, project) {
      state.project = project;
    },

    // Set planning projects
    setPlanningProjects(state, projects) {
      state.planning_projects = projects;
    },

    // Set project
    setProject(state, project) {
      state.project = project;
    },

    // Set project
    setDatatableParameters(state, options) {
      state.list_datatable_parameters = options;
    },

    // Set project
    setSearch(state, options) {
      state.list_search = options;
    }
  },
  actions: {
    // Fetch projects from API
    async fetchProjects({ state, commit }) {
      // Pagination options
      const { page, itemsPerPage } = state.pagination;

      // Filter options
      const {
        date_type,
        date_from,
        date_to,
        applicator,
        unprocessed,
        search
      } = state.filter;

      // Request parameters
      const params = {
        page,
        itemsPerPage: itemsPerPage > 0 ? itemsPerPage : null,
        date_type: date_type || null,
        from: date_from ? date_from : null,
        to: date_to ? date_to : null,
        applicator: applicator ? applicator : null,
        unprocessed: unprocessed ? unprocessed : null,
        search: search ? search : null
      };

      console.log(params);

      // Trigger request
      const { data, meta } = await ProjectsRepo.get(params);

      // If ok, set items on state
      if (data && meta) {
        commit("SET_ITEMS", {
          items: data,
          totalItems: meta.total
        });
      }

      return data;
    },

    // Get all projects from api for plannings
    async fetchPlanningProjects({ commit }, { pagination, filters }) {
      try {
        // Pagination options
        const { page, itemsPerPage } = pagination;

        // Filter options
        const {
          date_type,
          date,
          printed,
          unprinted,
          on_order,
          unaffected,
          canceled,
          lastname,
          firstname
        } = filters;

        // Request parameters
        const params = {
          page,
          itemsPerPage: itemsPerPage > 0 ? itemsPerPage : null,
          date_type: date_type || null,
          date: date || null,
          printed: printed || null,
          unprinted: unprinted || null,
          on_order: on_order || null,
          unaffected: unaffected || null,
          canceled: canceled || null,
          lastname: lastname || null,
          firstname: firstname || null
        };

        const { data, total } = await ProjectsRepo.fetchPlanningProjects(
          params
        );
        commit("setPlanningProjects", data);

        return { data, total };
      } catch (error) {
        throw error;
      }
    },

    // Get project light from api
    async fetchProjectLight(context, project_uuid) {
      try {
        const { data } = await ProjectsRepo.getProjectLight(project_uuid);
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Get project from server
     */
    async getProject({ commit }, project_uuid) {
      try {
        const { data } = await ProjectsRepo.getProject(project_uuid);

        commit("SET_PROJECT", data);

        return data;
      } catch (error) {
        throw error;
      }
    },

    // Update project
    async updateProject(context, { project_uuid, payload }) {
      try {
        const { data } = await ProjectsRepo.updateProject(
          project_uuid,
          payload
        );
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Update project light
    async updateProjectLight(context, { project_uuid, payload }) {
      try {
        const { data } = await ProjectsRepo.updateProjectLight(
          project_uuid,
          payload
        );
        return data;
      } catch (error) {
        throw error;
      }
    },

    // Fetch calculation
    async fetchCalculation(context, project_uuid) {
      try {
        return await ProjectsRepo.getCalculation(project_uuid);
      } catch (error) {
        throw error;
      }
    },

    // Get project articles
    async fetchProjectArticles(context, { project_uuid, type }) {
      try {
        const { data } = await ProjectsRepo.getProjectArticles(
          project_uuid,
          type
        );
        return data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },

    // Creates project article
    async createProjectArticle(context, { project_uuid, payload }) {
      try {
        return await ProjectsRepo.addProjectArticle(project_uuid, payload);
      } catch (error) {
        throw error;
      }
    },

    // Deletes project articles
    async deleteProjectArticles(context, { project_uuid, payload }) {
      try {
        return await ProjectsRepo.deleteProjectArticles(project_uuid, payload);
      } catch (error) {
        throw error;
      }
    },

    // Updates project article
    async updateProjectArticle(context, { project_uuid, payload }) {
      try {
        return await ProjectsRepo.updateProjectArticle(project_uuid, payload);
      } catch (error) {
        throw error;
      }
    },

    // Get articles by search
    async fetchArticlesBySearch(context, search_term) {
      try {
        return await ArticlesRepository.get(search_term);
      } catch (error) {
        throw error;
      }
    },

    // Clean store
    async cleanProjects({ commit }) {
      commit("setProjects", []);
      return;
    },

    // Clean store
    async cleanProject({ commit }) {
      commit("cleanProject");
      return;
    }
  },

  getters: {
    projects: state => {
      return state.items.map(item => {
        if (item.product_model) {
          item.product_name = productsObject[item.product_model].name;
        }

        return item;
      });
    },

    uncancelledProjects: state => {
      return state.items.filter(project => !project.idc_cancelled);
    }
  }
};
